import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";
import { C2Text, C4Text, T3Text } from "../text/CustomText";
import { Column, Padding, Row, SizedBox } from "../CommonBaseComponents";
import { Theme } from "../../Theme";

function PieTooltip({ active, data }) {
    if (active && data && data.length) {
        const total = data.reduce((sum, entry) => sum + entry.value, 0);

        return (
            <div
                style={{
                    backgroundColor: Theme.color.white,
                    border: `1px solid ${Theme.color.zinc300}`,
                    borderRadius: "8px",
                    padding: "16px 20px",
                    boxShadow: `0 4px 12px ${Theme.color.black_01}`,
                }}
            >
                {/* Total */}
                <Padding padding={"3px 0"}>
                    <T3Text fontColor={Theme.color.zinc850}>Total {total}</T3Text>
                </Padding>

                {/* 항목 리스트 */}
                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        gap: "20px",
                    }}
                >
                    {data.map((entry, index) => (
                        <div
                            key={`item-${index}`}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                            }}
                        >
                            {/* 1. 색상 막대 */}
                            <div
                                style={{
                                    width: "5px",
                                    height: "36px",
                                    backgroundColor: entry.color,
                                    borderRadius: "3px",
                                }}
                            />

                            {/* 2. 텍스트 (이름 + 값) */}
                            <Column alignItem={"flex-start"}>
                                <C4Text fontColor={Theme.color.gray500}>{entry.name}</C4Text>
                                <SizedBox height={"4px"} />
                                <C2Text fontColor={Theme.color.zinc850} fontWeight={"500"}>
                                    {entry.value}
                                </C2Text>
                            </Column>
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    return null;
}

function CustomPieChart({ title, data }) {
    return (
        <div style={{ width: "100%", height: 250 }}>
            <Row width={"100%"} justifyContent={"center"} alignItem={"center"}>
                <C2Text textAlign={"center"} fontColor={Theme.color.gray500}>
                    {title}
                </C2Text>
            </Row>

            <ResponsiveContainer>
                <PieChart>
                    <Pie
                        data={data}
                        cx="50%"
                        cy="50%"
                        innerRadius={0}
                        outerRadius={100}
                        fill={Theme.color.indigo400}
                        paddingAngle={0}
                        dataKey="value"
                        labelLine={false}
                        label={false}
                    >
                        {data.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={entry.color} />
                        ))}
                    </Pie>
                    <Tooltip content={<PieTooltip data={data} />} isAnimationActive={false} />
                </PieChart>
            </ResponsiveContainer>
        </div>
    );
}

export default CustomPieChart;
